import React from 'react'

import type { PageMeta } from '../../generated/frontend'

interface MetaProps {
  meta: Partial<PageMeta>
  additionalMeta?: JSX.Element[]
  indexType?: 'index' | 'noindex'
  followType?: 'follow' | 'nofollow'
}

export const useGenericMetaTags = () => {
  return {
    getGenericMetaTags({
      meta,
      additionalMeta = [],
      indexType = 'index',
      followType = 'follow',
    }: MetaProps) {
      const pageTitle = `${meta.title ?? ''} - Which?`
      const pageDesc = meta.desc ?? ''
      const baseMetaTags = [
        <title key="title">{pageTitle}</title>,
        <meta key="description" name="description" content={pageDesc} />,
        <link key="canonical" rel="canonical" href={meta.canonical} />,
        <link key="favicon" rel="shortcut icon" href="/favicon.ico" type="image/ico" />,
        <meta key="robots" name="robots" content={`${indexType}, ${followType}`} />,
        <meta key="language" name="language" content="en" />,
        <meta key="country" name="country" content="GB" />,
      ]
      const xMetaTags = [
        <meta
          key="twitter:title"
          name="twitter:title"
          content={meta.socialData?.twitter?.title || pageTitle}
        />,
        <meta
          key="twitter:description"
          name="twitter:description"
          content={meta.socialData?.twitter?.description || pageDesc}
        />,
        <meta key="twitter:card" name="twitter:card" content="summary" />,
        <meta key="twitter:site" name="twitter:site" content="@whichuk" />,
        <meta key="twitter:creator" name="twitter:creator" content="@whichuk" />,
        <meta key="twitter:url" name="twitter:url" content={meta.canonical} />,
      ]
      const facebookMetaTags = [
        <meta key="fb:app_id" property="fb:app_id" content={meta.fbAppId} />,
        <meta
          key="og:title"
          property="og:title"
          content={meta.socialData?.og?.title || pageTitle}
        />,
        <meta
          key="og:description"
          property="og:description"
          content={meta.socialData?.og?.description || pageDesc}
        />,
        <meta key="og:type" property="og:type" content="website" />,
        <meta key="og:url" property="og:url" content={meta.canonical} />,
        <meta key="og:site_name" property="og:site_name" content="Which?" />,
        <meta key="og:locale" property="og:locale" content="en_GB" />,
        <meta key="fb:pages" property="fb:pages" content="" />,
      ]

      return [...baseMetaTags, ...xMetaTags, ...facebookMetaTags, ...additionalMeta]
    },
  }
}
